import { authClient, API } from "../index";
import i18n from "../../i18n";

// Get all texts
export const getTexts = () => {
  return authClient().get(`${API}/text`);
};

// Get text by id
export const getTextById = (id) => {
  return authClient().get(`${API}/text/${id}`);
};

/**
 * Obtiene el texto según el idioma actual de i18n
 * 
 * IMPORTANTE: Los códigos ISO en la base de datos (tabla Language, campo isocode) deben coincidir
 * con los códigos de idioma usados en i18n. Los idiomas soportados actualmente son:
 * - es (Español)
 * - en (English)
 * - ca (Català)
 * - fr (Français)
 * - de (Deutsch)
 * - pt (Português)
 * - zh (中文)
 * - ru (Русский)
 * - ja (日本語)
 * 
 * Los textos en la base de datos deben tener el campo `content` como un objeto con estas claves:
 * { es: "...", en: "...", ca: "...", ... }
 * 
 * @param {Object} content - Objeto con las traducciones del texto (ej: { es: "...", en: "...", ca: "..." })
 * @param {string} fallbackLang - Idioma de fallback si no se encuentra el texto (default: "es")
 * @returns {string} - El texto en el idioma actual o fallback
 */
export const getTextByLanguage = (content, fallbackLang = "es") => {
  if (!content || typeof content !== "object") {
    return "";
  }

  // Obtener el idioma actual de i18n
  const currentLang = i18n.language || fallbackLang;
  
  // Extraer el código base del idioma (ej: "ca-ES" -> "ca", "en-US" -> "en")
  const langCode = currentLang.split("-")[0].toLowerCase();

  // Intentar obtener el texto con el código del idioma actual
  if (content[langCode]) {
    return content[langCode];
  }

  // Fallback al idioma especificado
  if (content[fallbackLang]) {
    return content[fallbackLang];
  }

  // Si no existe el fallback, intentar con "en"
  if (fallbackLang !== "en" && content["en"]) {
    return content["en"];
  }

  // Si no existe nada, devolver el primer valor disponible o string vacío
  const firstKey = Object.keys(content)[0];
  return firstKey ? content[firstKey] : "";
};
